import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Importa tu componente principal App

// Este archivo es el punto de entrada de tu aplicación React.
// Aquí se "monta" el componente App en el elemento HTML con id="root".

// Para el entorno local, no necesitamos las variables globales de Canvas (__firebase_config, etc.)
// ya que la conexión a la base de datos se hará a través de tu API de Flask.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App /> {/* Renderiza el componente App */}
  </React.StrictMode>
);
